export const codeLanguages = ["typescript", "python", "shell"] as const;

export type CodeLanguage = (typeof codeLanguages)[number];
export type CodeTemplate = CodeLanguage | "react" | "agent";

type TemplateStep = {
  entryPoint?: string;
  defaultHasOutput: boolean;
};

export const templateSteps: Record<CodeTemplate, TemplateStep> = {
  shell: { entryPoint: "script.sh", defaultHasOutput: false },
  python: { entryPoint: "script.py", defaultHasOutput: false },
  typescript: { entryPoint: "script.ts", defaultHasOutput: false },
  react: { entryPoint: "App.tsx", defaultHasOutput: true },
  agent: { entryPoint: "agent.ts", defaultHasOutput: false },
};
